var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "自动合并订单设置",
        visible: _vm.mergeOrderDialogVisible,
        "close-on-click-modal": false,
        width: "550px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.mergeOrderDialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "padding-top-bottom-10" },
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "font-size-14",
                  on: { change: _vm.autoFlagFn },
                  model: {
                    value: _vm.autoFlag,
                    callback: function ($$v) {
                      _vm.autoFlag = $$v
                    },
                    expression: "autoFlag",
                  },
                },
                [_vm._v("自动合并订单")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "auto-setting" }, [
            _c("div", { staticClass: "padding-top-bottom-10 font-weight" }, [
              _vm._v("自定义合并数量："),
            ]),
            _c(
              "div",
              { staticClass: "padding-top-bottom-10" },
              [
                _vm._v("满足条件时，最多每 "),
                _c(
                  "el-select",
                  {
                    attrs: { disabled: !_vm.autoFlag, placeholder: "请选择" },
                    model: {
                      value: _vm.settingNum,
                      callback: function ($$v) {
                        _vm.settingNum = $$v
                      },
                      expression: "settingNum",
                    },
                  },
                  _vm._l(20, function (item) {
                    return item > 1
                      ? _c("el-option", {
                          key: item,
                          attrs: { label: item, value: item },
                        })
                      : _vm._e()
                  }),
                  1
                ),
                _vm._v(" 笔订单自动合并成一笔订单。 "),
              ],
              1
            ),
            _c("div", { staticClass: "padding-top-bottom-10 color-red" }, [
              _vm._v("注意："),
            ]),
            _c("div", { staticClass: "color-red" }, [
              _vm._v("1.该规则仅针对系统自动合并订单；"),
            ]),
            _c("div", { staticClass: "color-red" }, [
              _vm._v(
                "2.规则修改保存后，历史订单如果满足自动合并规则会进行再次合并"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.saveMergeOrderSetting },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }